import { KATALOG, LEER, type Schluessel, type Wert } from '../../platform/einstellungen';

/**
 * Wie die Vorschau eines Einstellungscodes einen Wert zeigt.
 *
 * ⚠️ **Jedes Passwort verdeckt**, nicht nur die bekannten: massgeblich ist `geheim` im Katalog.
 * Relays Code trägt auch `communication_password` und `exit_pin` im Klartext — über die
 * Schulter gelesen wären sie genauso weg wie abfotografiert.
 */
export function zeigeWert(schluessel: Schluessel, wert: Wert | typeof LEER | null, leerText: string): string {
  // Ein geleertes Passwort verrät nichts — Punkte täuschten eins vor, das es nicht gibt.
  if (wert === LEER || wert === null) return leerText;
  if (KATALOG[schluessel].geheim) return '••••••';
  return String(wert);
}

/**
 * Was den Serverzugang ausmacht. Ein falscher Wert sperrt das Gerät aus — deshalb steht der
 * Block in der Vorschau zuoberst und nicht irgendwo zwischen 39 Zeilen von Relays Code.
 */
export const ZUGANG: readonly Schluessel[] = [
  'server_protocol',
  'server_url',
  'communication_login',
  'communication_password',
  'classic_login',
  'classic_password',
];

/** Teilt die Vorschau: Serverzugang in fester Reihenfolge, der Rest nach Beschriftung. */
export function ordneVorschau<W>(
  eintraege: [Schluessel, W][],
  beschriftung: (s: Schluessel) => string,
): { zugang: [Schluessel, W][]; uebrige: [Schluessel, W][] } {
  const zugang = ZUGANG.flatMap((s) => eintraege.filter(([k]) => k === s));
  const uebrige = eintraege
    .filter(([k]) => !ZUGANG.includes(k))
    .sort(([a], [b]) => beschriftung(a).localeCompare(beschriftung(b)));
  return { zugang, uebrige };
}
